export default {
  namespaced: true,
  state: {
    list: {},
  },
}
